import { useEffect, useState } from 'react';

export const useShowScrollToTopArrow = (compare = []) => {
  const [showScrollToTopArrow, setShowScrollToTopArrow] = useState(false);

  useEffect(() => {
    const el = document.querySelector('[data-grid-cell-position="10"]');
    if (el) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.boundingClientRect.top >= 0) {
          // below the 10th grid element
          setShowScrollToTopArrow(false);
        } else {
          // above the 10th grid element
          setShowScrollToTopArrow(true);
        }
      });

      observer.observe(el);

      return () => {
        observer.unobserve(el);
      };
    }

    setShowScrollToTopArrow(false);
  }, compare);

  return showScrollToTopArrow;
};
